// service统一出口
import HTTPRequest from '..'
import { local } from '@/utils/storage'
import permissionHeader from '@/utils/permissionHeader'

const httpRequest = new HTTPRequest({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: process.env.VUE_APP_API_TIMEOUT,
  interceptors: {
    requestInterceptor: (config) => {
      config.headers.token = config?.specialToken || local.get('TOKEN')
      config.headers = {
        ...config.headers,
        ...permissionHeader()
      }
      return config
    },
    requestInterceptorCatch: (err) => {
      return err
    },
    responseInterceptor: (res) => {
      return res
    },
    responseInterceptorCatch: (err) => {
      return err
    }
  }
})

export default httpRequest
